<template>
  <div class="card width-750" v-if="demandeTechnique">
    <header class="bandeau-modal card-header">
    </header>
    <div class="center">
      <div class="columns is-gapless">
        <div class="column mgt-20px">
          <h1 class="title is-size-3" v-if="demande">
            {{ $t('catalogue.demandeInterventionType.popUpAddEdit.titleEdit') }}
          </h1>
          <h1 class="title is-size-3" v-else>
            {{ $t('catalogue.demandeInterventionType.popUpAddEdit.titleAdd') }}
          </h1>
        </div>
      </div>
    </div>
    <div class="card-content">
      <error-msg-component
        :messages="messages"
        :error="error"
        :messagesChampsVide="messagesChampsVide"
        :champsVide="champsVide"
        :title="'general.problemOccurred'"
        :withEmplyFields="true"
        @close="error = $event"/>
      <div class="columns is-multiline">
        <b-field
          :label="$t('catalogue.demandeInterventionType.tab.ordreRealisation')"
          class="column is-narrow mgb-0 obligatoire">
          <b-input
            v-model.number="demandeTechnique.ordreRealisation"
            type="number"
            min="1"
            :use-html5-validation="false">
          </b-input>
        </b-field>
        <b-field
          :label="$t('catalogue.demandeInterventionType.tab.typeDemande')"
          class="column is-4 mgb-0 obligatoire">
          <b-select
            v-model="demandeTechnique.typeDemande"
            expanded>
            <option
              v-for="item in constantes.TYPE_INTERVENTION"
              :key="item.key"
              :value="item.key">
              {{ $t(item.libelle) }}
            </option>
          </b-select>
        </b-field>
        <b-field
          :label="$t('catalogue.demandeInterventionType.tab.typeOt')"
          class="column is-4 mgb-0"
          v-if="isInterventionTypeIsIntervention"
          :class="{ 'obligatoire' :
            demandeTechnique.typeDemande === constantes.INTERVENTION_TYPE_INTERVENTION }">
          <b-select
            v-model="demandeTechnique.typeOtId"
            expanded>
            <option :value="null"></option>
            <option
              v-for="item in typesOT"
              :key="item.id"
              :value="item.id">
              {{ item.libelle }}
            </option>
          </b-select>
        </b-field>
        <b-field
          :label="$t('catalogue.demandeInterventionType.tab.sujet')"
          class="column is-12 mgb-0 obligatoire">
          <b-input v-model.trim="demandeTechnique.sujet" type="textarea" rows="4"/>
        </b-field>
      </div>
      <footer>
        <b-field>
          <div class="is-pulled-left boutonAction">
            <a class="button" @click="$parent.close()">
              {{ $t('general.button.cancel')}}
            </a>
          </div>
          <div class="is-pulled-left boutonAction">
            <a class="button is-addOrEdit" @click="saveOrAddLigne()">
              {{ !isDetail ? $t('general.button.valider') : $t('general.button.sauvegarder') }}
            </a>
          </div>
        </b-field>
      </footer>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import { TYPE_INTERVENTION, INTERVENTION_TYPE_INTERVENTION } from '@/configuration/logistique/intervention/interventionConf';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import genererDemandeInterventionType from '@/services/catalogue/commun/genererDemandeInterventionType';
import messageErreur from '@/services/general/messageErreur';
import { create, update } from '@/api/demandeInterventionType/index';
import validationGeneral, { removeDuplicateMsgError } from '@/services/validation/validation';
import validationProduit from '@/services/catalogue/validation/validationProduit';
import translate from '@/services/catalogue/validation/champsProduitTranslator';
import errorMsgComponent from '@/components/general/errorMsgComponent';

const Parametres = createNamespacedHelpers('parametres');

export default {
  props: {
    demande: {
      type: Object,
      required: false,
    },
    produit: {
      type: Object,
      required: true,
    },
    isDetail: {
      type: Boolean,
    },
  },
  components: {
    errorMsgComponent,
  },
  data() {
    return {
      demandeTechnique: null,
      constantes: {
        TYPE_INTERVENTION,
        INTERVENTION_TYPE_INTERVENTION,
      },
      error: false,
      messages: [],
      messagesChampsVide: [],
      champsVide: [],
    };
  },
  computed: {
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    typesOT() {
      return this.parametre(PARAMETRES_KEYS.typeOt);
    },
    isInterventionTypeIsIntervention() {
      return this.demandeTechnique.typeDemande === this.constantes.INTERVENTION_TYPE_INTERVENTION;
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    updateDemande() {
      const index = this.produit.demandeInterventionTypes
        .findIndex(d => d.id === this.demande.id);
      if (index !== -1) {
        this.produit.demandeInterventionTypes.splice(index, 1, this.demandeTechnique);
      }
    },
    addLigne() {
      if (this.demande) this.updateDemande();
      else this.produit.demandeInterventionTypes.push(this.demandeTechnique);
      this.$parent.close();
    },
    async saveOrAddLigne() {
      if (this.demandeTechnique.typeDemande
        !== this.constantes.INTERVENTION_TYPE_INTERVENTION) {
        this.demandeTechnique.typeOtId = null;
      }
      if (!this.isDetail) {
        this.addLigne();
        return;
      }
      await this.save();
    },
    async save() {
      const loadingComponent = this.$buefy.loading.open();
      this.error = false;
      this.messages = [];
      this.messagesChampsVide = [];
      this.champsVide = [];
      try {
        if (this.demande) {
          await update(this.demandeTechnique);
          this.updateDemande();
        } else {
          delete this.demandeTechnique.isCreate;
          delete this.demandeTechnique.id;
          const result = (await create(this.demandeTechnique)).data.result;
          this.produit.demandeInterventionTypes.push(result);
        }
        this.$parent.close();
      } catch (e) {
        if (e.response.data.error) {
          this.error = true;
          this.messages = validationProduit(e.response);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          this.messages = removeDuplicateMsgError(this.messages);
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      } finally {
        loadingComponent.close();
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametres([PARAMETRES_KEYS.typeOt]);
      if (this.demande) {
        this.demandeTechnique = cloneDeep(this.demande);
      } else {
        this.demandeTechnique = genererDemandeInterventionType();
        this.demandeTechnique.produitId = this.produit.id;
      }
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>

<style>

</style>
